import React from "react";
import { useTranslation } from "react-i18next";

const LeadsConnectionErrorMessage = ({ app, errorMessage }) => {
  const [t] = useTranslation();
  const getMessages = [
    { app: "facebook", name: "permission_denied", msg: t("__fb_error_permission_denied") },
    { app: "facebook", name: "token_expire", msg: t("__fb_error_token_expire") },
    { app: "google", name: "file_permission_denied", msg: t("__google_error_file_permission_denied") },
    { app: "google", name: "token_expire", msg: t("__google_error_token_expire") },
    { app: "google", name: "gsheet_not_found", msg: t("__google_error_gsheet_not_found") },
    { app: "google", name: "403_insert_fail", msg: t("__google_error_403_insert_fail") },
    { app: "rcrm", name: "gate_lost", msg: t("__rcrm_error_gate_lost") },
  ];

  const errorMsg = getMessages.find((item) => item.app === app && item.name === errorMessage);

  return errorMsg != undefined ? <div>{errorMsg.msg}</div> : <div>{t("__connection_problem")}</div>;
};

export default LeadsConnectionErrorMessage;
